import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function AutoRedirect() {
  const history = useHistory();

  useEffect(() => {
    // Open the new URL in a new tab
    window.open("http://arreportsql/ReportServer/Pages/ReportViewer.aspx?%2fTHRaporlar%2fGenel%2fServisFotograflari&rs:Command=Render", '_blank');

    // Go back to the previous URL
    history.goBack();
  }, [history]);

  // Return null to render nothing
  return null;
}

export default AutoRedirect;
